import React from 'react';
import logo from '../assets/logo.png'
import {Link} from "react-router";
function Giris() {
    return (
        <section className="account">
            <div className="account__bid">
                <img src="assets/images/thumb/account-bid.png" alt=""/>
            </div>
            <Link to="/" className="account-close" reloadDocument>
                <i className="las la-times"/>
            </Link>
            <div className="account-left">
                <div className="account-left__logo">
                    <a className="account-left__logo-link" href="index.html">
                        {" "}
                        <img src={logo} alt=""/>
                    </a>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <form action="#" autoComplete="off">
                                <h2 className="account-title text-uppercase">
                                    YAPAY ZEKA DEMO GİRİŞ
                                </h2>
                                <div className="row gy-4">

                                    <div className="col-sm-12">
                                        <input
                                            type="email"
                                            className="form--control"
                                            placeholder="Email Address"
                                        />
                                    </div>
                                    <div className="col-sm-12">
                                        <input
                                            type="password"
                                            className="form--control"
                                            placeholder="Şifre"
                                        />
                                    </div>

                                    <div className="col-sm-12">
                                        <p className="contact-content__desc">Demo girişi için kullanıcı bilgileri almak istiyorsanız, <Link style={{color:"#7e2a82"}} to="/iletisime-gecin" reloadDocument>iletişime geçin</Link></p>
                                    </div>
                                    <div className="col-sm-12">
                                        <button type="submit" className="btn--base style-two">
                                            GİRİŞ
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="account-right">
                <div className="account-right__thumb">
                    <img src="assets/images/thumb/account-man-img.png" alt=""/>
                </div>
            </div>
        </section>

    );
}

export default Giris;